import { useUserPermissions } from "../_hooks/useUserPermissions";

/**
 * Mounts the current-user-permissions query for the app shell's lifetime.
 *
 * Just calling useUserPermissions() is enough to trigger the fetch -
 * useGetCurrentUserPermissionsQuery already has refetchOnMountOrArgChange:
 * true, so it fetches on mount on its own. This component used to ALSO
 * manually call refetch() in an effect keyed on "permissions not loaded yet"
 * - redundant with the query's own auto-fetch, and actively harmful on a
 * persistent failure (e.g. a 403 for an org the user has no role in): since
 * userPermissions never gets set, that condition stayed true forever, so
 * every time isLoading settled back to false the effect fired refetch()
 * again - an unbounded retry loop hammering the failing endpoint. Other call
 * sites (post-login, post-org-switch) already call refetch() explicitly when
 * something has actually changed; that's the right place for retries to
 * happen, not a background poller here.
 */
const PermissionInitializer = () => {
  useUserPermissions();

  // This component doesn't render anything
  return null;
};

export default PermissionInitializer;
